import {
  GET_GROUPS,
  GET_MEMBERS,
  SET_GROUPS,
  SET_MEMBERS,
  GET_GROUPS_ERROR,
  GET_MEMBERS_ERROR,
  RESET_GROUPS,
  RESET_MEMBERS
} from './types'

const initialState = {
  groups: [],
  groupsNext: null,
  members: [],
  membersNext: null,
  isLoadingGroups: false,
  isLoadingMembers: false
}

const groupsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_GROUPS:
      return {
        ...state,
        isLoadingGroups: true
      }
    case GET_MEMBERS:
      return {
        ...state,
        isLoadingMembers: true
      }
    case SET_GROUPS:
      return {
        ...state,
        groups: action.payload.groups,
        groupsNext: action.payload.groupsNext,
        isLoadingGroups: false
      }
    case SET_MEMBERS:
      return {
        ...state,
        members: action.payload.members,
        membersNext: action.payload.membersNext,
        isLoadingMembers: false
      }
    case GET_GROUPS_ERROR:
      return {
        ...state,
        isLoadingGroups: false
      }
    case GET_MEMBERS_ERROR:
      return {
        ...state,
        isLoadingMembers: false
      }
    case RESET_GROUPS:
      return {
        ...state,
        groups: [],
        isLoadingGroups: false
      }
    case RESET_MEMBERS:
      return {
        ...state,
        members: [],
        isLoadingMembers: false
      }
    default:
      return state
  }
}

export default groupsReducer
